"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAlert = void 0;
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledAlert = (0, styled_components_1.default)(material_1.Alert) `
  &.MuiAlert-root {
    font-size: 0.875rem;
    align-items: center;

    .MuiAlert-message {
      white-space: break-spaces;
      max-height: 100px;
      overflow-y: auto;
      color: ${({ theme }) => theme.palette.accent.main};
    }
  }

  &.MuiAlert-outlinedSuccess,
  &.MuiAlert-outlinedInfo {
    background-color: ${ui_components_1.baseColors.primaryBlue100};
    border-color: ${ui_components_1.baseColors.primaryBlue200};

    .MuiAlert-icon {
      color: ${ui_components_1.baseColors.blue300};
    }
  }
  
  &.MuiAlert-outlinedError {
    background-color: ${ui_components_1.baseColors.red100};
    border-color: ${ui_components_1.baseColors.alertsRed15};
  }

  &.MuiAlert-outlinedWarning {
    // Temporary color
    background-color: #FFF7F0;
  }

  &.MuiAlert-standardSuccess {
    background-color: ${ui_components_1.baseColors.background000};
    color: ${({ theme }) => theme.palette.accent.main};
  }

  &.MuiAlert-standardError {
    background-color: ${ui_components_1.baseColors.alertsRed15};
    color: ${({ theme }) => theme.palette.accent.main};
  }

  &&.MuiAlert-outlined {
    box-shadow: none;
  }
`;
